import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateItemTypeMutationVariables = Types.Exact<{
  create: Types.CreateItemType;
}>;


export type CreateItemTypeMutation = { __typename?: 'Mutation', createItemType: { __typename?: 'ItemType', id: number } };


export const CreateItemTypeDocument = gql`
    mutation CreateItemType($create: CreateItemType!) {
  createItemType(create: $create) {
    id
  }
}
    `;
export type CreateItemTypeMutationFn = Apollo.MutationFunction<CreateItemTypeMutation, CreateItemTypeMutationVariables>;

/**
 * __useCreateItemTypeMutation__
 *
 * To run a mutation, you first call `useCreateItemTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateItemTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createItemTypeMutation, { data, loading, error }] = useCreateItemTypeMutation({
 *   variables: {
 *      create: // value for 'create'
 *   },
 * });
 */
export function useCreateItemTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateItemTypeMutation, CreateItemTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateItemTypeMutation, CreateItemTypeMutationVariables>(CreateItemTypeDocument, options);
      }
export type CreateItemTypeMutationHookResult = ReturnType<typeof useCreateItemTypeMutation>;
export type CreateItemTypeMutationResult = Apollo.MutationResult<CreateItemTypeMutation>;
export type CreateItemTypeMutationOptions = Apollo.BaseMutationOptions<CreateItemTypeMutation, CreateItemTypeMutationVariables>;